<template>
  <div class="full-height">
    <div v-if="isNotCanUseLayerControl" class="position-relative full-height">
      <v-overlay absolute class="px-8" :opacity="0.3">
        Dịnh vụ WMS đang tắt, không thể sử dụng tính năng xem trước
      </v-overlay>
    </div>
    <div v-else class="d-flex flex-column full-height">
      <div
        v-show="isAddLayer"
        class="flex-grow-1 overflow-auto"
        style="max-height:200px"
      >
        <LayerSelection
          @click:add="onAddLayer"
          :settings="settings"
          @click:add-layer-group="onAddLayerGroup"
          :layerIdSelect="layerIdSelect"
          :layerGroupIdSelect="layerGroupIdSelect"
        />
      </div>
      <v-divider v-if="isAddLayer" class="flex-grow-0"> </v-divider>
      <FilterSearch
        v-if="!readonly && c_layers.length > 0 && !isAddLayer"
        :canShowInSearch="false"
        v-model="params"
        disableCreate
        class="pa-1"
      ></FilterSearch>
      <div class="flex-grow-1 overflow-auto">
        <LayerList
          v-if="c_layers.length > 0"
          :layers.sync="c_layers"
          class="full-width"
          :class="{ 'pa-4': !readonly }"
          ref="layerGroup"
          :readonly="readonly"
          :selected.sync="itemsLayerSelect"
          @layer:action="onCallActionLayer"
          @click:delete-group="onDeleteGroup"
          :disabled="disabled"
        >
          <template #item="props">
            <slot name="item" v-bind="props" />
          </template>
          <template #extra-btn-item="props">
            <slot name="extra-btn-item" v-bind="props" />
          </template>
          <template #extra-btn-item-group="props">
            <slot name="extra-btn-item-group" v-bind="props" />
          </template>
        </LayerList>

        <div class="lc-pane__empty" v-else>
          <v-icon size="32" color="#DADCE0">
            mdi-layers-off-outline
          </v-icon>
          <p>Chưa có lớp nào</p>
        </div>
      </div>
      <div class="flex-grow-0">
        <slot name="extra-last" />
      </div>
    </div>
  </div>
</template>

<script>
import LayerSelection from './layer-selection.vue'
import LayerList from './layer-list.vue'
import FilterSearch from '@layouts/filter-search.vue'
import { LAYER_TYPE } from './model/layer'
export default {
  components: { LayerList, LayerSelection, FilterSearch },
  props: {
    settings: {},
    layerIdSelect: { type: Array, default: () => [] },
    layerGroupIdSelect: { type: Array, default: () => [] },
    layers: { type: Array, require: true },
    layerTree: { type: Array, require: true },
    disabled: Boolean,
    selected: { type: Array, default: () => [] },
    readonly: Boolean,
  },
  data: () => ({
    isAddLayer: false,
    params: { search: '' },
  }),
  watch: {},
  computed: {
    isNotCanUseLayerControl() {
      return (
        this.settings &&
        this.settings.data &&
        !this.settings.data.is_global_enable &&
        (!this.settings.data.workspaces_enabled ||
          this.settings.data.workspaces_enabled.length < 1)
      )
    },
    itemsLayerSelect: {
      get() {
        return this.selected
      },
      set(value) {
        this.$emit('update:selected', value)
      },
    },
    c_layer_filters() {
      let search = this.params.search || ''
      search = search.trim()
      if (search) {
        return this.layers.filter((x) => x.name.includes(search))
      }
      return this.layers
    },
    c_layers: {
      get() {
        return this.c_layer_filters
      },
      set(value) {
        this.$emit('update:layers', value)
      },
    },
  },
  methods: {
    onShowAddNewLayer() {
      this.isAddLayer = !this.isAddLayer
    },
    addNewGroup() {
      this.$refs.layerGroup.addNewGroup()
    },
    onCallActionLayer(e) {
      this.$emit('layer:action', e)
    },
    onAddLayer({ layers = [] } = {}) {
      this.$emit('click:add-layer', {
        layers: layers.map((x) => ({
          layer_type: LAYER_TYPE.NBDS_VECTO_LAYER,
          data_type: x.datastore_detail.type,
          info: x,
        })),
      })
    },
    onAddLayerGroup(value) {
      this.$emit('click:add-layer-group', value)
    },
    onDeleteGroup(group) {
      this.$emit('layer:action', { type: 'delete:group', layer: group })
    },
  },
}
</script>

<style scoped>
.lc-pane__empty {
  text-align: center;
  margin-top: 35px;
}
.lc-pane__empty p {
  font-size: 12px;
  line-height: 14px;
  margin-top: 8px;
}
.lc-pane__empty .v-icon {
  font-size: 30px;
}
</style>

<style lang="scss">
.lc-pane {
  &__title {
    display: flex;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    height: 47px;
    align-items: center;
    background: #f1f1f1;
    padding: 0 11px;
    padding-right: 8px;
    span {
      margin-left: 13px;
    }
  }

  &__empty {
    text-align: center;
    margin-top: 35px;
    .v-icon {
      font-size: 30px;
    }
    p {
      font-size: 12px;
      line-height: 14px;
      margin-top: 8px;
    }
  }
}
</style>
